/* MB CLEANINGS — Contact
   Simpel contactformulier (FormSubmit) + prijsschatting in een popup.
   De schatting kan als blok aan het bericht toegevoegd worden. */
(function() {
    const form = document.getElementById('contactForm');
    const modal = document.getElementById('pqModal');
    if (!form || !modal) return;

    const quoteCard = document.getElementById('cfQuote');
    const attached = document.getElementById('cfAttached');
    const addBtn = document.getElementById('pqAdd');
    const totalEl = document.getElementById('pqTotal');
    const noteEl = document.getElementById('pqNote');
    const subjectSelect = form.querySelector('select[name="topic"]');

    /* ══ AGENDA: enkel de boekbare dagen (standaard vr–za–zo) ══ */
    const DAY_NAMES = ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'];
    const dateInput = form.querySelector('input[name="date"]');
    (function() {
        const field = form.querySelector('.date-field');
        if (!field || !dateInput) return;
        const trigger = field.querySelector('#dateTrigger');
        const display = field.querySelector('#dateDisplay');
        const cal = field.querySelector('#calendar');
        const grid = field.querySelector('#calGrid');
        const monthEl = field.querySelector('#calMonth');
        const yearEl = field.querySelector('#calYear');
        const months = ['Januari','Februari','Maart','April','Mei','Juni','Juli','Augustus','September','Oktober','November','December'];

        const openDays = (field.dataset.openDays || '5,6,0').split(',').filter(Boolean).map(Number);
        const daysAhead = parseInt(field.dataset.daysAhead, 10) || 90;
        const today = new Date(); today.setHours(0, 0, 0, 0);
        const maxDate = new Date(today); maxDate.setDate(maxDate.getDate() + daysAhead);
        let view = new Date(today.getFullYear(), today.getMonth(), 1);
        let selected = null;

        const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
        const isBookable = (d) => d > today && d <= maxDate && openDays.includes(d.getDay());

        function render() {
            monthEl.textContent = months[view.getMonth()];
            yearEl.textContent = view.getFullYear();
            grid.innerHTML = '';
            const first = new Date(view.getFullYear(), view.getMonth(), 1);
            const last = new Date(view.getFullYear(), view.getMonth() + 1, 0).getDate();
            const offset = (first.getDay() + 6) % 7; // maandag eerst
            for (let i = 0; i < offset; i++) {
                const pad = document.createElement('div');
                pad.className = 'cal-day other-month';
                grid.appendChild(pad);
            }
            for (let day = 1; day <= last; day++) {
                const d = new Date(view.getFullYear(), view.getMonth(), day);
                const btn = document.createElement('button');
                btn.type = 'button';
                btn.className = 'cal-day';
                btn.textContent = day;
                if (!isBookable(d)) {
                    btn.classList.add(openDays.includes(d.getDay()) ? 'disabled' : 'closed');
                    btn.disabled = true;
                } else {
                    btn.classList.add('open-day');
                    btn.setAttribute('aria-label', `${DAY_NAMES[d.getDay()]} ${day} ${months[d.getMonth()]}`);
                    btn.addEventListener('click', () => { pick(d); close(); });
                }
                if (d.getTime() === today.getTime()) btn.classList.add('today');
                if (selected && d.getTime() === selected.getTime()) btn.classList.add('selected');
                grid.appendChild(btn);
            }
            const prev = field.querySelector('#calPrev');
            prev.disabled = view <= new Date(today.getFullYear(), today.getMonth(), 1);
            prev.style.opacity = prev.disabled ? 0.3 : '';
            const next = field.querySelector('#calNext');
            next.disabled = new Date(view.getFullYear(), view.getMonth() + 1, 1) > maxDate;
            next.style.opacity = next.disabled ? 0.3 : '';
        }

        function pick(d) {
            selected = d;
            dateInput.value = iso(d);
            dateInput.setCustomValidity('');
            display.textContent = `${DAY_NAMES[d.getDay()]} ${d.getDate()} ${months[d.getMonth()].toLowerCase()} ${d.getFullYear()}`;
            display.classList.remove('placeholder');
        }
        function open() { render(); cal.classList.add('open'); trigger.setAttribute('aria-expanded', 'true'); }
        function close() { cal.classList.remove('open'); trigger.setAttribute('aria-expanded', 'false'); }

        trigger.addEventListener('click', (e) => { e.stopPropagation(); cal.classList.contains('open') ? close() : open(); });
        cal.addEventListener('click', (e) => e.stopPropagation());
        document.addEventListener('click', close);
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
        field.querySelector('#calPrev').addEventListener('click', () => { view.setMonth(view.getMonth() - 1); render(); });
        field.querySelector('#calNext').addEventListener('click', () => { view.setMonth(view.getMonth() + 1); render(); });

        // Lege datum: duidelijke melding + kalender openen
        dateInput.setCustomValidity('Kies een datum in de kalender.');
        dateInput.addEventListener('invalid', () => { open(); trigger.focus(); });
    })();

    /* ══ WATER & STROOM: duidelijke foutmelding ══ */
    form.querySelectorAll('.toggle-required input[type="checkbox"]').forEach(cb => {
        const msg = cb.name === 'water_available'
            ? 'Water op locatie is nodig voor de behandeling.'
            : 'Stroom op locatie is nodig voor de behandeling.';
        const sync = () => cb.setCustomValidity(cb.checked ? '' : msg);
        cb.addEventListener('change', sync);
        sync();
    });

    /* ══ PRIJZEN — uit Theme Settings (window.MBC_PRICES / MBC_EXTRAS) of fallback ══ */
    const PRICES = Object.assign({
        'G-Wash|Auto|Regular': 250, 'G-Wash|Auto|Sport / SUV': 299,
        'G-Wash|Moto|Regular': 185, 'G-Wash|Moto|Sport / SUV': 185,
        'G-Wash|Quad|Regular': 185, 'G-Wash|Quad|Sport / SUV': 185,
        'Exterieur Reiniging|Regular': 185, 'Exterieur Reiniging|Sport / SUV': 200,
        'Interieur Reiniging|Regular': 100, 'Interieur Reiniging|Sport / SUV': 120, 'Interieur Reiniging|>6 Meter': 120,
        'Q2 Cancoat Pro|Regular': 500, 'Q2 Cancoat Pro|Sport / SUV': 550,
        'Q2 Pure|Regular': 700, 'Q2 Pure|Sport / SUV': 750,
        'Regular Package (Abonnement)|Regular|Maandelijks': 150, 'Regular Package (Abonnement)|Sport / SUV|Maandelijks': 200,
        'Regular Package (Abonnement)|Regular|Per kwartaal': 250, 'Regular Package (Abonnement)|Sport / SUV|Per kwartaal': 300,
        'Premium Package (Abonnement)|Regular|Maandelijks': 199, 'Premium Package (Abonnement)|Sport / SUV|Maandelijks': 249,
        'Premium Package (Abonnement)|Regular|Per kwartaal': 299, 'Premium Package (Abonnement)|Sport / SUV|Per kwartaal': 349
    }, window.MBC_PRICES || {});
    const EXTRAS = Object.assign({
        wetcoat: 20, cabrio: 50,
        q2wax_regular: 85, q2wax_sport: 120,
        stoom_regular: 50, stoom_sport: 75,
        geur: 25,
        fabric_regular: 30, fabric_sport: 45,
        leer_regular: 50, leer_sport: 75,
        polish_start: 50
    }, window.MBC_EXTRAS || {});
    const POLISH_HOURLY = 75;

    // Extra's: value → prijs-sleutel (met _regular/_sport variant waar nodig)
    const EXTRA_KEYS = {
        'Wetcoat': 'wetcoat',
        'Cabrio dak reiniging + coating': 'cabrio',
        'Q2 Wax (Exterieur)': 'q2wax',
        'Stoomreiniging': 'stoom',
        'Geurbehandeling': 'geur',
        'Fabric coat': 'fabric',
        'Leer reiniging + behandeling': 'leer'
    };

    const q = (sel) => modal.querySelector(sel);
    const val = (name) => { const el = q(`input[name="${name}"]:checked`); return el ? el.value : ''; };
    // Interne waarden blijven Regular / Sport / SUV (prijs-sleutels), klant ziet Klasse 1 / 2
    const CLASS_LABELS = { 'Regular': 'Klasse 1', 'Sport / SUV': 'Klasse 2', '>6 Meter': '> 6 Meter' };
    const isLarge = () => ['Sport / SUV', '>6 Meter'].includes(val('vehicle_type'));

    function extraPrice(value) {
        const key = EXTRA_KEYS[value];
        if (!key) return 0;
        if (EXTRAS[key] !== undefined) return EXTRAS[key];
        return isLarge() ? EXTRAS[key + '_sport'] : EXTRAS[key + '_regular'];
    }

    /* ══ BEREKENING ══
       Geeft { amount, label } terug. amount = null → (nog) geen prijs. */
    function calculate() {
        const svc = val('service');
        const veh = val('vehicle_type');
        const coat = val('coating_type');
        const period = val('subscription_period');
        const gwashCat = val('gwash_category') || 'Auto';
        if (!svc) return { amount: null, label: 'Kies een dienst' };

        const needsCoating = svc === 'GYEON Coatings';
        const needsPeriod = svc.includes('(Abonnement)');
        if (needsCoating && !coat) return { amount: null, label: 'Kies een coating' };
        if (needsPeriod && !period) return { amount: null, label: 'Kies maandelijks of per kwartaal' };
        if (!veh) return { amount: null, label: 'Kies uw type voertuig' };
        if (veh !== '>6 Meter' && !val('body_type')) return { amount: null, label: 'Kies het type koetswerk' };

        // Diensten zonder vaste prijs
        if (['Mobiele Detailing', 'Verkoopsklaar maken', 'Check & Fix'].includes(svc)) {
            return { amount: null, label: 'Op aanvraag', onRequest: true };
        }
        // >6 Meter = op aanvraag (zie prijslijst)
        if (veh === '>6 Meter' && (svc === 'Exterieur Reiniging' || svc === 'G-Wash' || needsCoating)) {
            return { amount: null, label: 'Op aanvraag', onRequest: true };
        }

        let total;
        if (svc === 'Polishing') {
            total = EXTRAS.polish_start;
        } else if (svc === 'G-Wash') {
            total = PRICES[`G-Wash|${gwashCat}|${veh}`];
        } else if (needsCoating) {
            total = PRICES[`${coat}|${veh}`];
        } else if (needsPeriod) {
            total = PRICES[`${svc}|${isLarge() ? 'Sport / SUV' : 'Regular'}|${period}`];
        } else {
            total = PRICES[`${svc}|${veh}`];
        }
        if (!total) return { amount: null, label: 'Op aanvraag', onRequest: true };

        // Opbouw van de prijs (gaat mee in de mail)
        const breakdown = [`${svc}: €${total}${svc === 'Polishing' ? ` (start) + €${POLISH_HOURLY}/u` : ''}`];
        modal.querySelectorAll('.conditional.active input[type="checkbox"]:checked').forEach(cb => {
            const p = extraPrice(cb.value) || 0;
            total += p;
            breakdown.push(`+ ${cb.value}: €${p}`);
        });

        const label = svc === 'Polishing'
            ? `€${total} + €${POLISH_HOURLY}/u`
            : `€${total}`;
        return { amount: total, label, breakdown };
    }

    /* ══ UI IN DE POPUP ══ */
    function updateConditionals() {
        const svc = val('service').toLowerCase();
        modal.querySelectorAll('.conditional').forEach(el => {
            const showFor = (el.dataset.showFor || '').split(',').map(s => s.trim().toLowerCase());
            const on = showFor.includes(svc);
            el.classList.toggle('active', on);
            // Verborgen extra's niet meetellen
            if (!on) el.querySelectorAll('input[type="checkbox"]').forEach(cb => { cb.checked = false; });
        });
        // Koetswerk-keuze enkel tonen voor de gekozen klasse
        const veh = val('vehicle_type');
        modal.querySelectorAll('.pq-bodytypes').forEach(el => {
            const on = el.dataset.showForVehicle === veh;
            el.classList.toggle('active', on);
            if (!on) el.querySelectorAll('input').forEach(r => { r.checked = false; });
        });
    }

    function updateExtraLabels() {
        modal.querySelectorAll('[data-extra-price]').forEach(el => {
            el.textContent = `+€${extraPrice(el.dataset.extraPrice)}`;
        });
    }

    function refresh() {
        updateConditionals();
        updateExtraLabels();
        const r = calculate();
        totalEl.textContent = r.label;
        totalEl.classList.toggle('is-empty', r.amount === null && !r.onRequest);
        noteEl.textContent = r.onRequest
            ? 'We bekijken uw voertuig en bezorgen u een prijs op maat.'
            : 'Indicatief — definitieve prijs na bekijken van uw voertuig.';
        addBtn.disabled = r.amount === null && !r.onRequest;
    }
    modal.addEventListener('change', refresh);

    /* ══ OPENEN / SLUITEN ══ */
    let lastFocus = null;
    function openModal() {
        lastFocus = document.activeElement;
        refresh();
        modal.classList.add('open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('pq-locked');
        setTimeout(() => q('.pq-close').focus(), 50);
    }
    function closeModal() {
        modal.classList.remove('open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('pq-locked');
        if (lastFocus) lastFocus.focus();
    }
    document.addEventListener('click', (e) => {
        if (e.target.closest('[data-pq-open]')) { e.preventDefault(); openModal(); }
        else if (e.target.closest('[data-pq-close]') || e.target === modal) closeModal();
    });
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.classList.contains('open')) closeModal();
    });

    /* ══ SCHATTING TOEVOEGEN AAN BERICHT ══ */
    let estimate = null;
    const quoteDefaultHTML = quoteCard.innerHTML;

    function buildEstimate() {
        const svc = val('service');
        const r = calculate();
        const lines = [`Dienst: ${svc}`];
        if (svc === 'G-Wash') lines.push(`Voertuig: ${val('gwash_category') || 'Auto'}`);
        if (val('coating_type') && svc === 'GYEON Coatings') lines.push(`Coating: ${val('coating_type')}`);
        if (val('subscription_period') && svc.includes('(Abonnement)')) lines.push(`Abonnement: ${val('subscription_period')}`);
        lines.push(`Type voertuig: ${CLASS_LABELS[val('vehicle_type')] || val('vehicle_type')}${val('body_type') ? ' — ' + val('body_type') : ''}`);
        const extras = Array.from(modal.querySelectorAll('.conditional.active input[type="checkbox"]:checked')).map(cb => cb.value);
        if (extras.length) lines.push(`Extra's: ${extras.join(', ')}`);
        return { service: svc, lines, breakdown: r.breakdown || [], price: r.label };
    }

    function escapeHTML(s) {
        return s.replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    }

    function renderQuoteCard() {
        if (!estimate) {
            quoteCard.classList.remove('has-estimate');
            quoteCard.innerHTML = quoteDefaultHTML;
            if (attached) attached.hidden = true;
            return;
        }
        if (attached) {
            attached.hidden = false;
            attached.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke-width="2.5"><path d="M20 6 9 17l-5-5"/></svg>
                <span>Uw prijsschatting (<strong>${escapeHTML(estimate.price)}</strong> — ${escapeHTML(estimate.service)}) wordt meegestuurd.</span>`;
        }
        quoteCard.classList.add('has-estimate');
        quoteCard.innerHTML = `
            <div class="cf-quote-text">
                <span class="cf-quote-eyebrow">Uw prijsschatting</span>
                <span class="cf-quote-price">${escapeHTML(estimate.price)}</span>
                <span class="cf-quote-lines">${estimate.lines.map(escapeHTML).join('<br>')}</span>
            </div>
            <button type="button" class="cf-quote-btn" id="cfQuoteSend">
                Verstuur met berekening
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12h14M13 5l7 7-7 7"/></svg>
            </button>
            <div class="cf-quote-actions">
                <button type="button" class="cf-link-btn" data-pq-open>Aanpassen</button>
                <button type="button" class="cf-link-btn" id="cfQuoteRemove">Verwijderen</button>
            </div>`;
        quoteCard.querySelector('#cfQuoteRemove').addEventListener('click', () => {
            estimate = null;
            renderQuoteCard();
        });
        // Verstuurt het formulier; ontbrekende velden (naam/e-mail) toont de browser zelf
        quoteCard.querySelector('#cfQuoteSend').addEventListener('click', () => {
            if (form.reportValidity()) form.requestSubmit();
        });
    }

    addBtn.addEventListener('click', () => {
        estimate = buildEstimate();
        // Onderwerp meteen invullen als dat nog leeg is
        if (subjectSelect && !subjectSelect.value) subjectSelect.value = estimate.service;
        renderQuoteCard();
        closeModal();
        // Naar het formulier, eerste lege verplichte veld (naam/e-mail) klaarzetten
        const firstEmpty = Array.from(form.querySelectorAll('[required]')).find(el => !el.value.trim());
        (attached || form).scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (firstEmpty) firstEmpty.focus({ preventScroll: true });
    });

    /* ══ VOORSELECTIE via ?service= of sessionStorage (prijslijst-knoppen) ══ */
    (function() {
        const params = new URLSearchParams(window.location.search);
        let wanted = params.get('service') || sessionStorage.getItem('mbc_service') || '';
        const period = params.get('period') || sessionStorage.getItem('mbc_period') || '';
        sessionStorage.removeItem('mbc_service');
        sessionStorage.removeItem('mbc_period');
        if (!wanted) return;

        const aliases = {
            'coatings': 'GYEON Coatings',
            'lakcorrecties & polijsten': 'Polishing',
            'lakcorrecties en polijsten': 'Polishing'
        };
        let coating = '';
        if (/q2 pure|cancoat/i.test(wanted)) { coating = /cancoat/i.test(wanted) ? 'Q2 Cancoat Pro' : 'Q2 Pure'; wanted = 'GYEON Coatings'; }
        const lookup = (aliases[wanted.toLowerCase()] || wanted).toLowerCase();

        const radios = Array.from(modal.querySelectorAll('input[name="service"]'));
        const match = radios.find(r => r.value.toLowerCase() === lookup)
            || radios.find(r => r.value.toLowerCase().includes(lookup) || lookup.includes(r.value.toLowerCase()));
        if (!match) return;
        match.checked = true;
        if (coating) { const c = q(`input[name="coating_type"][value="${coating}"]`); if (c) c.checked = true; }
        if (period) { const p = q(`input[name="subscription_period"][value="${period}"]`); if (p) p.checked = true; }
        if (subjectSelect) subjectSelect.value = match.value;
        refresh();
    })();

    /* ══ VERSTUREN via FormSubmit ══
       We bundelen alles in één leesbaar tekstblok, zodat de mail netjes is. */
    form.addEventListener('submit', function(e) {
        e.preventDefault();
        const submitBtn = form.querySelector('.submit-btn');
        submitBtn.innerHTML = 'Bezig met versturen...';
        submitBtn.disabled = true;

        const get = (n) => { const el = form.querySelector(`[name="${n}"]`); return el ? el.value.trim() : ''; };

        const yesNo = (n) => { const el = form.querySelector(`[name="${n}"]`); return el && el.checked ? 'Ja' : 'Nee'; };
        const d = get('date');
        const dateNL = d ? `${DAY_NAMES[new Date(d + 'T12:00:00').getDay()]} ${d.split('-').reverse().join('/')}` : '—';
        const address = `${get('street')} ${get('house_nr')}${get('bus_nr') ? ' bus ' + get('bus_nr') : ''}, ${get('postal_code')} ${get('city')}`;

        const summary = [
            '════════════════════════════════════',
            '   NIEUWE AANVRAAG — MB CLEANINGS',
            '════════════════════════════════════',
            '',
            '━━ KLANT ━━',
            `Naam: ${get('name')}`,
            `E-mail: ${get('email')}`,
            `Telefoon: ${get('phone')}`,
            '',
            '━━ AFSPRAAK ━━',
            `Gewenste datum: ${dateNL}`,
            `Voertuig: ${get('vehicle')}`,
            `Adres: ${address}`,
            `Water beschikbaar: ${yesNo('water_available')}`,
            `Stroom beschikbaar: ${yesNo('power_available')}`,
            '',
            get('message') ? `━━ BERICHT ━━\n${get('message')}\n` : null,
            estimate ? [
                '━━ PRIJSSCHATTING (berekend door klant) ━━',
                ...estimate.lines,
                '',
                ...(estimate.breakdown.length ? ['Opbouw:', ...estimate.breakdown] : []),
                `GESCHATTE PRIJS: ${estimate.price}`,
                ''
            ].join('\n') : '(geen prijsschatting gemaakt)\n',
            '════════════════════════════════════'
        ].filter(l => l !== null).join('\n');

        const ensure = (tag, name, type) => {
            let el = form.querySelector(`[name="${name}"]`);
            if (!el) {
                el = document.createElement(tag);
                el.name = name;
                if (type) el.type = type;
                el.style.display = 'none';
                form.appendChild(el);
            }
            return el;
        };
        ensure('textarea', 'Bericht').value = summary;

        // Bevestigingsmail voor de klant: intro (theme setting) + korte samenvatting
        const auto = form.querySelector('input[name="_autoresponse"]');
        if (auto) {
            if (!auto.dataset.intro) auto.dataset.intro = auto.value;
            const firstName = get('name').split(' ')[0];
            auto.value = [
                `Hallo ${firstName},`,
                '',
                auto.dataset.intro,
                '',
                'Uw aanvraag:',
                `- Gewenste datum: ${dateNL}`,
                `- Voertuig: ${get('vehicle')}`,
                `- Adres: ${address}`,
                estimate ? `- Prijsschatting: ${estimate.service}, ${estimate.price} (indicatief)` : null,
                get('message') ? `- Uw bericht: ${get('message')}` : null,
                '',
                'Met vriendelijke groeten,',
                'MB Cleanings'
            ].filter(l => l !== null).join('\n');
        }
        ensure('input', '_replyto', 'hidden').value = get('email');
        const subj = form.querySelector('input[name="_subject"]');
        if (subj) subj.value = estimate
            ? `Aanvraag ${estimate.service} (${estimate.price}) — ${get('name')} — ${dateNL}`
            : `Nieuwe aanvraag — ${get('name')} — ${dateNL}`;

        // Enkel het samengevatte blok meesturen (geen losse Engelse veldnamen in de mail)
        const keep = new Set(['Bericht', 'email', '_subject', '_template', '_captcha', '_next', '_honey', '_replyto', '_autoresponse']);
        form.querySelectorAll('input, textarea, select').forEach(el => { if (!keep.has(el.name)) el.disabled = true; });

        form.submit();
    });

    // Terug-knop in browser: velden weer bruikbaar maken
    window.addEventListener('pageshow', () => {
        form.querySelectorAll('[disabled]').forEach(el => { el.disabled = false; });
        const submitBtn = form.querySelector('.submit-btn');
        if (submitBtn && submitBtn.dataset.label) submitBtn.innerHTML = submitBtn.dataset.label;
    });
    const sb = form.querySelector('.submit-btn');
    if (sb) sb.dataset.label = sb.innerHTML;
})();
